import {EntityData, field, identifier} from "@fedeltapointofsale/data-client";

export class ManufacturerData extends EntityData<ManufacturerData> {
    @identifier manufacturerId: number;
    @field name: string;
    @field description: string;

}
